export const versions = {
  version: "1.0.183",
  revision: "717ae30c0",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5110-g717ae30c0-dirty",
    hash: "g717ae30c0",
    distance: 5110,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5110-g717ae30c0-dirty",
    semverString: "1.0.183+5110.g717ae30c0.dirty"
  }
};
